var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 39.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6fwRkP.tif",
    "data-name": " 6fwRkP.tif",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M12.21,27.36V23.79a1.43,1.43,0,0,0,0-.22,4.76,4.76,0,0,1,4.26-4.1l.75,0-.13-.1a4.15,4.15,0,0,1,1.76-7c.23-.07.48-.1.72-.16h.78l.2,0a4.16,4.16,0,0,1,2.27,7.12l-.08.1c.25,0,.49,0,.72,0A4.72,4.72,0,0,1,27.62,23c.07.27.11.54.16.81v3.57a.73.73,0,0,1-.38.39H12.6A.73.73,0,0,1,12.21,27.36Zm1-.66h13.5V24.16a3.72,3.72,0,0,0-3.68-3.68H16.94a3.71,3.71,0,0,0-3.55,2.76,4.53,4.53,0,0,0-.13,1C13.24,25,13.25,25.86,13.25,26.7ZM20,13.21a3.12,3.12,0,1,0,3.1,3.13A3.11,3.11,0,0,0,20,13.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M12.21,27.36a.68.68,0,0,0,.39.39h-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M27.4,27.75a.68.68,0,0,0,.39-.39v.39Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIcon);
export default __webpack_public_path__ + "static/media/AccountsIcon.305dc6031b4acb130c49f24472c29a7d.svg";
export { ForwardRef as ReactComponent };